
























import Vue from 'vue'
import ChartCardContainer from '@/components/layouts/ChartCardContainer.vue'
import { Optional } from '@/types/common'
import { InhalerCompliance } from '@/jsonapi/CommonTypes'
import JsonApiUtils from '@/jsonapi/JsonApiUtils'
import { getAdherenceRateChartOptions } from '@/components/patient-stats/graphs/summary-reports/chart-options/maintenance-inhaler-charts/AdherenceRateChartOptions'

export default Vue.extend({
  components: {
    ChartCardContainer,
  },
  props: {
    patientId: {
      type: String,
      required: true,
    },
    patientWithStats: {
      type: Object,
      required: true,
    },
  },
  computed: {
    inhalerCompliances(): Optional<InhalerCompliance[]> {
      if (!this.patientWithStats) {
        return null
      }
      const allCompliances: Optional<InhalerCompliance[]> = this.patientWithStats.inhalerCompliances
      if (!allCompliances) {
        return null
      }
      return JsonApiUtils.getMaintenanceInhalerCompliances(allCompliances)
    },
    hasData() {
      return this.inhalerCompliances && this.inhalerCompliances.length > 0
    },
    hasBadData() {
      if (!this.hasData) {
        return false
      }
      const percentage = this.inhalerCompliances[0].compliancePerc
      return percentage < 0 || percentage > 100
    },
    adherenceRateChartOptions() {
      return getAdherenceRateChartOptions(this.inhalerCompliances)
    },
  },
})
